<template>
  <div class="contents">
    <h1>Block</h1>

    <div class="contents__detail-box">
      <div class="contents__detail-table contents__block-detail-table">
        <div class="row">
          <span class="field">BLOCK NUMBER</span>
          <span class="value">{{ block.block_number.toLocaleString() }}</span>
        </div>

        <div class="row">
          <span class="field">
            TIME(UTC +0)
            <FieldNotice :text="TIME_BLOCK_TOOLTIP" />
          </span>
          <span class="value">{{ block.tx_created_time }}</span>
        </div>

        <div class="row">
          <span class="field">TOTAL TXS</span>
          <span class="value">{{ block.tx_count }}</span>
        </div>

        <div class="row">
          <span class="field">BLOCK HASH</span>
          <span class="value">{{ block.block_hash }}</span>
        </div>

        <div class="row">
          <span class="field">DATA HASH</span>
          <span class="value">{{ block.data_hash }}</span>
        </div>

        <div class="row">
          <span class="field">PREVIOUS HASH</span>
          <span class="value">
            <router-link class="link" :to="`/blocks/${block.previous_hash}`">
              {{ block.previous_hash }}
            </router-link>
          </span>
        </div>
      </div>
    </div>

    <div v-if="txs.length" class="contents--list">
      <div class="contents--list-subject">
        <span>Transactions</span>
        <RecordSelectBox v-if="needPagination" :record="record" @changeRecord="changeRecord" />
      </div>

      <Table width="900px" data-type="txs" :data="txs" />

      <Pagination
        v-if="needPagination"
        :lastPage="(this.totalPage == this.currentPage)"
        :firstPage="(this.currentPage == 1)"
        :isDetail="true"
        :totalPage="totalPage"
        :currentPage="currentPage"
        :loading="loading"
        @flip="pageCall"
      />
    </div>
  </div>
</template>

<script>
import RecordSelectBox from "./shared/RecordSelectBox.vue";
import Table from "./shared/Table.vue";
import Pagination from "./shared/Pagination.vue";
import FieldNotice from "./shared/FieldNotice.vue";
import callAPI from "../../api/http";
import err from "../../js/error";
import { convertAttrFormat } from "../../js/format";
import { RecordOptions, TIME_BLOCK_TOOLTIP } from "../../js/fields";
import { styleNav } from "../../js/style";

export default {
  props: {
    bookmark: {
      type: Number,
      default: undefined,
    },
    pagesize: {
      type: Number,
      default: RecordOptions[0],
    },
    direction: {
      type: String,
      default: "first",
    },
    id: {
      type: Number,
      default: 0,
    },
  },

  components: {
    RecordSelectBox,
    Table,
    Pagination,
    FieldNotice,
  },

  async beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    this.bookmark = to.query.bookmark || undefined;
    this.pagesize = to.query.pagesize || RecordOptions[0];
    this.direction = to.query.direction || "first";

    this.record = this.pagesize;

    await this.getBlockDetail();
    next();
  },

  async created() {
    this.record = this.pagesize;

    await this.getBlockDetail();
  },

  mounted() {
    styleNav(2);
  },

  data() {
    return {
      TIME_BLOCK_TOOLTIP,
      block: {},
      txs: [], // object array
      currentPage: 0,
      totalPage: 0,
      pagesize: RecordOptions[0],
      loading: false,
    };
  },

  computed: {
    needPagination() {
      if (this.totalPage <= 1) {
        return false;
      }
      return true;
    }
  },

  methods: {
    async getBlockDetail() {
      const { data: block, errCode } = await callAPI("getBlockDetail", this.id);
      if (errCode) {
        err(errCode, this.id, this.$router);
        return;
      }

      this.block = block;
      this.block_num = block.block_number;

      await this.getTxsOfBlock();
    },

    async getTxsOfBlock() {
      this.loading = true;
      let param = {
        bookmark: this.bookmark,
        pagesize: this.pagesize,
        direction: this.direction,
        block_num: this.block_num,
      };
      const { data, errCode } = await callAPI("getTxsOfBlock", param);
      this.setTxs(data, errCode);
    },

    async pageCall(direction) {
      switch (direction) {
        case "next":
          this.bookmark = this.txs[this.txs.length - 1].id;
          this.direction = direction;
          if (this.bookmark == this.minID) {
            return;
          }
          await this.getTxsOfBlock();
          break;
        case "prev":
          this.bookmark = this.txs[0].id;
          this.direction = direction;
          if (this.bookmark == this.maxID) {
            return;
          }
          await this.getTxsOfBlock();
          break;
        default:
          this.bookmark = undefined;
          this.direction = direction;
          await this.getTxsOfBlock();
      }
    },

    async changeRecord(pagesize) {
      if (this.pagesize == pagesize) {
        return;
      }
      this.record = pagesize; // not re-routing, must set new record
      this.pagesize = pagesize;
      this.direction = "first"; // reset to fist page
      await this.getTxsOfBlock();
    },

    setTxs(data, errCode) {
      if (errCode) {
        console.log(errCode);
        this.loading = false;
        return;
      }

      const { txs, current_page, total_page } = data;

      if (txs) {
        this.txs = convertAttrFormat("TransactionsList", txs);
        this.currentPage = current_page;
        this.totalPage = total_page;
        if (this.currentPage == this.totalpage) {
          this.lastPage == true;
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/common";

.contents__block-detail-table {
  @include detailTableFieldWidth(150px);
}
</style>




// WEBPACK FOOTER //
// src/components/contents/BlockDetail.vue